<title>{{ apiInformation.htmlTitle }}</title>
<app-banner [banner]="apiInformation.banner"></app-banner>
<div class="container mt-5 mb-5">
<app-modal #modal></app-modal>
<div *ngFor="let tableSection of apiInformation.tableSections" class="CommonTable EqualColumn">
  <div class = offline-airline-profile-table>
    <h2 id="{{ tableSection.heading }}">{{ tableSection.title }}</h2>
    <p *ngIf="tableSection.body !== ''">{{ tableSection.body }}</p>
    <div [innerHtml]="returnHtmlFromRichText(tableSection.table) | mdToHtml"></div>
  </div>
</div>